"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _CodeSplitEnvWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/CodeSplitEnvWrapper"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Container = _styledComponents.default.div.withConfig({
  displayName: "BundlesCtaContainer__Container",
  componentId: "sc-1enag8c-0"
})(["height:60px;width:100%;.uiButton{width:100%;height:100%;display:flex;align-items:center;justify-content:center;}"]);

var BundlesContainer = function BundlesContainer(props) {
  return _react.default.createElement(Container, null, _react.default.createElement(_CodeSplitEnvWrapper.default, {
    authedComponentLoader: function authedComponentLoader() {
      return import(
      /* webpackChunkName: "authed-chunk" */
      "pricing-pages-unified-ui/components/bundle-page/BundlesAuthedCta");
    },
    publicComponentLoader: function publicComponentLoader() {
      return import(
      /* webpackChunkName: "public-chunk" */
      "pricing-pages-unified-ui/components/public-only/PublicPurchaseMotionButton");
    },
    authedComponentProps: Object.assign({}, props),
    publicComponentProps: {
      use: 'primary',
      sourceId: 'pricing-middle',
      nonMerchandiseIdProduct: 'bundle'
    }
  }));
};

var _default = BundlesContainer;
exports.default = _default;
module.exports = exports.default;